import script from "./GetHelpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GetHelpPage.vue?vue&type=script&setup=true&lang=js"

import "./GetHelpPage.vue?vue&type=style&index=0&id=efe7a7d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe7a7d0"]])

export default __exports__